// extracted by mini-css-extract-plugin
module.exports = {"content":"cookies_content__sn_ZE","block":"cookies_block__DuqPH"};